import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Button, Dimmer, Input, Loader, Modal, Segment, Table, Visibility} from "semantic-ui-react";
import TableStyled from "../../../components/Table/Table.jsx";
import './styles.scss'
import ConfirmModal from "../../../components/Modals/ConfirmModal";
import {apiPost} from "../../../services/apiClient";
import {toast} from "react-toastify";
import debounce from "lodash.debounce";

const SelectPointModal = ({trigger, setOpen, open, label, setPoint, companyId}) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [allCount, setAllCount] = useState(0);
    const [delItem, setDelItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [myAddresses, setMyAddresses] = useState([]);
    const take = 50;

    const ref = useRef();
    const loadMyAddresses = (companyId, skip, searchQuery) => {
        setLoading(true)
        apiPost('myaddresses/available/' + companyId, {
            search: searchQuery,
            take,
            skip
        })
            .then(data => {
                data.totalCount && setAllCount(data.totalCount)
                setLoading(false);
                setMyAddresses(prevState => skip === 0 ? data.entries : [...prevState, ...data.entries]);
            })
            .catch(err => {
                setLoading(false);
                console.log(err)
            });
    }

    const loadMyAddressesDebounce = useCallback(debounce(loadMyAddresses, 500), []);

    useEffect(() => {
        if (open && companyId) {
            loadMyAddressesDebounce(companyId, 0, searchQuery)
            ref.current.scrollTop = 0;
        }
        else setMyAddresses([]);
    }, [open, companyId, searchQuery])

    const onSelect = (entry) => {
        setPoint(null, {value: entry ? {...entry, ...(entry.address || {})} : {}});
        setOpen(false);
    }
    const onDelete = (entry) => {
        entry.isEditable
            ? setDelItem(entry.id)
            : toast.error("Адрес создан администратором вашей компании для всех сотрудников, его нельзя удалить")
    }

    const deleteAddress = () => {
        setLoading(true)
        apiPost(`myaddresses/delete/${delItem}`).then(d => {
            loadMyAddresses(companyId, 0, searchQuery);
            setDelItem(null);
            d.warnings && toast.error(d.warnings)
            !d.warnings && toast.success('Адрес удален')
        }).catch(e => {
            setLoading(false);
            setDelItem(null);
            toast.error('При удалении произошла ошибка')
            console.log(e)
        })
    }

    const renderTableRows = () => {
        return (myAddresses || []).map((entry, index) => (
            <Table.Row key={entry.id + "_" + index}>
                <Table.Cell>
                    <Button className='modal__table-btn' onClick={() => onSelect(entry)}>
                        Выбрать
                    </Button>
                </Table.Cell>
                <Table.Cell>
                    {entry.addressName}
                </Table.Cell>
                <Table.Cell>
                    {entry.contactName}
                </Table.Cell>
                <Table.Cell>
                    {entry.companyName}
                </Table.Cell>
                <Table.Cell>
                    <Button className='modal__table-btn modal__table-btn_red' onClick={() => onDelete(entry)}>
                        Удалить
                    </Button>
                </Table.Cell>
            </Table.Row>
        ));
    }
    
    return (
        <Modal
            closeIcon
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={trigger}
            size='large'
        >
            <Modal.Header>
                {label}
            </Modal.Header>
            <Modal.Content>
                <Segment vertical>
                    <Dimmer active={loading} inverted>
                        <Loader size='medium'/>
                    </Dimmer>
                    <div className='modal__search'>
                        <Input
                            fluid
                            icon='search'
                            iconPosition='left'
                            placeholder='Поиск по адресу, контакту, компании, телефону...'
                            onChange={e => setSearchQuery(e.target.value)}
                        />
                    </div>
                    <div className='modal__table' ref={ref}>
                        <TableStyled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell/>
                                    <Table.HeaderCell>Адрес</Table.HeaderCell>
                                    <Table.HeaderCell>Контактное лицо</Table.HeaderCell>
                                    <Table.HeaderCell>Компания</Table.HeaderCell>
                                    <Table.HeaderCell/>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {
                                    renderTableRows()
                                }
                            </Table.Body>
                        </TableStyled>
                        <Visibility
                            continuous={false}
                            once={false}
                            onTopVisible={() => {
                                allCount > myAddresses.length && loadMyAddresses(companyId, myAddresses.length, searchQuery)
                            }}
                            style={{bottom: 0, left: 0, right: 0, top: '-200px', position: 'relative'}}
                        />
                    </div>
                </Segment>
            </Modal.Content>
            <Modal.Actions>
                <Button className='modal__btn-cancel' onClick={() => setOpen(false)}>
                    Отмена
                </Button>
            </Modal.Actions>
            <ConfirmModal
                open={!!delItem}
                setOpen={(v) => setDelItem(v ? delItem : null)}
                label={`Удаление адреса`}
                onConfirm={deleteAddress}
            >
                Вы уверены, что хотите удалить адрес?
            </ConfirmModal>
        </Modal>
    );
};

export default SelectPointModal;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/selectPointModal.jsx